import { render, staticRenderFns } from "./ExtendedForms.vue?vue&type=template&id=358bfa52"
import script from "./ExtendedForms.vue?vue&type=script&lang=js"
export * from "./ExtendedForms.vue?vue&type=script&lang=js"
import style0 from "./ExtendedForms.vue?vue&type=style&index=0&id=358bfa52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports